<template>
  <div>
    <div class="head">
      <h1 class="global-title">{{ $t('mbs-switch') }}</h1>
      <!-- <div class="head-btn">
        <button @click="handleBack" class="back">{{ $t('btn-back') }}</button>
        <button @click="handleSave" :class="{ isUse: currentIndex === useNowCardIndex }">
          {{ $t('btn-save') }}
        </button>
      </div> -->
    </div>

    <div class="content">
      <ul>
        <li
          class="membership-info-wrapper"
          :class="{ selected: index === currentIndex }"
          v-for="(card, index) in cardList"
          :key="index"
          @click="handleSelect(card, index)"
        >
          <div class="membership-info">
            <div class="card-logo">
              <img v-if="card.bankLogoThumbNails" :src="card.bankLogoThumbNails" alt="bank logo" />
              <div class="card-status">
                <div class="card-in-use-tag" v-if="card.isSelected === '1'">
                  {{ $t('mbs-switch-card-use') }}
                </div>
                <img :src="index === currentIndex ? Selected : NotSelected" alt="select icon" />
              </div>
            </div>
            <p class="membership-no">{{ formatCardNo(card.dragonCode) }}</p>
            <div class="membership-others-info">
              <div>
                <span v-if="card.status === 9"
                  ><span>{{ $t('entitlement-refresh') }}</span>
                  <span>: </span>
                  <span>{{ card.cardValidDate }}</span></span
                >
                <span v-else class="invalid-card">{{ $t(getCardStatus(card)) }}</span>
              </div>
              <div>
                <span>{{ card.issueName }}</span>
                <span>, </span>
                <span>{{ card.cardType }}</span>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div
            v-if="card.canDelink"
            class="remove-membership-btn"
            @click="e => removeMembership(e, card)"
          >
            <img src="~img/icon-remove.svg" alt="select icon" />
            <p>{{ $t('delink-remove-btn') }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer-btn">
      <button @click="handleBack" class="back">{{ $t('btn-cancel') }}</button>
      <button @click="handleSave" :class="{ isUse: currentIndex === useNowCardIndex }">
        {{ $t('mbs-switch') }}
      </button>
    </div>
  </div>
</template>

<script>
  // import radio from '@/assets/images/radio.png';
  // import radioSelect from '@/assets/images/radio-select.png';
  import Selected from '@/assets/images/icon-selected-dark.svg';
  import NotSelected from '@/assets/images/icon-not-selected-dark.svg';
  import { mapMutations, mapState } from 'vuex';
  import { formatCardNo } from '@/utils/index';

  export default {
    name: 'SwitchMembership',

    mounted() {
      this.getAccountList();
    },

    data() {
      return {
        useNowCardIndex: 0,
        cardList: [],
        currentIndex: 0,
        currentCard: {},
        cardUseTitle: '',
        // radio,
        // radioSelect,
        Selected,
        NotSelected,
      };
    },
    computed: {
      ...mapState(['userInfo', 'bankLogo']),
    },
    methods: {
      formatCardNo,
      wrapperBrandTag(str) {
        /* eslint-disable*/
        function abc(match, p1) {
          return `<sup>${p1.slice(1, p1.length - 1)}</sup>`;
        }

        return str?.replace(/(\{[^\{\}]+\})/g, abc).replaceAll('®', '<sup>®</sup>');
      },
      handleBack() {
        // this.$router.go(-1);
        this.$router.push({ name: 'Membership' });
      },
      getBankLogo() {
        const { userId } = this.userInfo;
        this.$http.account.getBankLogo({ userId }).then(res => {
          this.setHeaderBankLogo(res.data.topLogo);
        });
      },

      async handleSave() {
        const { userId, sessionId } = this.userInfo;
        if (this.currentIndex === this.useNowCardIndex) {
          return;
        }
        const { dragonCode, visaCardType, agentId } = this.currentCard;
        const validData = {
          userId,
          sessionId,
          dragonCode,
          version: '1.0.0',
          lang: localStorage.getItem('lang'),
          // deviceId: JSON.parse(localStorage.getItem('currentDeviceName')),
          deviceId: localStorage.getItem('deviceId'),
        };
        const data = {
          dragonCode,
          userId,
          sessionId,
        };
        const validRes = await this.$http.member.creditCardValid(validData);
        // 校验通过，成功切卡 (目前ingenicoType和vcesCheckResult是不会同时需要校验的)
        if (validRes.payload.ingenicoType === 2 && validRes.payload.vcesCheckResult === 0) {
          console.log('success');
          await this.$http.member.setDefaultCard(data).then(res => {
            if (res?.state === '11') {
              sessionStorage.setItem('visaCardType', visaCardType);
              this.$store.commit('setState', {
                state: 'visaCardType',
                values: visaCardType,
              });
              this.$store.commit('setState', {
                state: 'userInfo',
                values: {
                  ...this.userInfo,
                  agentId,
                },
              });
              this.getAccountList(true);
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res?.note,
                confirmBtn: 'ok',
                justHide: true,
                i18nNeed: false,
                // successCallback: this.jumpRouter,
                // nextStep: '/account/membership',
              });
              console.error(res.note);
            }
          });
          await this.getBankLogo();
        } else if (validRes.payload.ingenicoType === 1) {
          // 跳转至update页面，并且此时保持未登录状态
          this.$messageModal.show({
            image: false,
            closeIcon: false,
            title: 'update-tip-title',
            desc: 'update-tip-desc',
            confirmBtn: 'btn-ok',
            cancelBtn: 'btn-cancel',
            justHide: true,
            i18nNeed: true,
            successCallback: () => {
              // 需要更新卡
              this.$router.push({
                name: 'UpdateVisaCard',
                query: {
                  dpid: dragonCode,
                },
              });
            },
          });
        } else if (validRes.payload.vcesCheckResult === 1) {
          // 已切换卡
          this.$store.commit('setState', {
            state: 'vcesStatus',
            values: 1,
          });
          sessionStorage.setItem('vcesStatus', 1);
          location.reload();
        } else if (validRes.payload.vcesCheckResult === 2) {
          // 未匹配大客户
          this.$store.commit('setState', {
            state: 'vcesStatus',
            values: 2,
          });
          sessionStorage.setItem('vcesStatus', 2);
          location.reload();
        }
      },

      handleSelect(card, index) {
        this.currentIndex = index;
        this.currentCard = card;
      },

      getCardSelectStatus(data) {
        const { isSelected } = data;
        return isSelected === 1 ? 'mbs-switch-card-use' : 'mbs-switch-card-not-use';
      },

      getCardStatus(data) {
        const { status } = data;
        if (status === 8) return 'mbs-switch-card-suspended';
        if (status === 7) return 'mbs-switch-card-expired';
        return null;
      },

      setTitleColor(data) {
        const { status, isSelected } = data;
        if (status === 9) return isSelected === 1 ? '#C29D5C' : '#54606C';
        if (status === 8 || status === 7) return '#CC2222';
      },

      // TODO: 两处在用，可以抽离到vuex中 获取membership页面数据
      getAccountList(switchSuccess = false) {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          // device: 'web',
          // version: '1.0.0',
          lang: this.$i18n.locale,
          sessionId,
          deviceId: localStorage.getItem('deviceId') || '',
        };
        this.$http.member.getAccountList(data).then(
          res => {
            if (res.state === '11') {
              this.cardList = res.payload;
              // 设置当前默认被选中的项
              const selectIndex = res.payload.findIndex(item => item.isSelected === '1');
              this.currentIndex = selectIndex;
              this.useNowCardIndex = selectIndex;

              // 切换成功后跳转会membership页面
              if (switchSuccess) {
                this.$router.push({ name: 'Membership', query: { switchSuccess: true } });
              }
            } else {
              console.error(res);
            }
          },
          err => {
            console.error(err);
          },
        );
      },
      removeMembership(e, card) {
        e.stopPropagation();
        sessionStorage.setItem('removeCardInfo', JSON.stringify(card));
        this.$router.push({
          name: 'RemoveMembership',
        });
      },

      ...mapMutations(['showMessageModal', 'setHeaderBankLogo']),
    },
  };
</script>

<style lang="scss" scoped>
@use './index';
@use './mobile';
</style>
